import consumeHandoff from './consumeHandoff'
import hasAccessToken from './hasAccessToken'
import isHandoffPending from './isHandoffPending'
import resumeSession from './resumeSession'


/**
 * Acquires an access token from the sign-in handoff when one is waiting, and
 * from the refresh cookie otherwise.
 *
 * A handoff that turns up empty falls back to the refresh cookie too, since
 * that cookie is set by the same sign-in.
 *
 * @returns {Promise} resolves once the attempt is over, whether or not a token
 *   was acquired
 */
export default async function acquireAccessToken() {
  // A handoff that rejects must not cost the visitor the refresh that would
  // still recover their session.
  if ( isHandoffPending() ) {
    await consumeHandoff()
      .catch(() => {})
  }

  if ( hasAccessToken() ) {
    return
  }

  await resumeSession()
}
